import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../../../components/form/form-field';
import SaveButton from '../../../../../components/form/save-button';

const S3DirectoryListTaskForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="s3DirectoryListTaskFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="s3DirectoryListTaskFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="s3DirectoryListTaskFormFunction"
        label="function"
        name="function"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.function?.message}
        defaultValue="s3DirectoryList"
      />
      <FormField
        controlId="s3DirectoryListTaskFormS3Bucket"
        label="s3Bucket"
        name="parameters.s3Bucket"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter S3 bucket name"
        required
        error={errors.parameters?.s3Bucket?.message}
      />
      <FormField
        controlId="s3DirectoryListTaskFormPrefix"
        label="prefix"
        name="parameters.prefix"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter prefix (optional)"
        error={errors.parameters?.prefix?.message}
      />
      <FormField
        controlId="s3DirectoryListTaskFormRecursive"
        label="recursive"
        name="parameters.recursive"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
        error={errors.parameters?.recursive?.message}
      />
      <FormField
        controlId="s3DirectoryListTaskFormAwsAccessKeyId"
        label="awsAccessKeyId"
        name="parameters.awsAccessKeyId"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter AWS Access Key ID"
        required
        error={errors.parameters?.awsAccessKeyId?.message}
      />
      <FormField
        controlId="s3DirectoryListTaskFormAwsSecretAccessKey"
        label="awsSecretAccessKey"
        name="parameters.awsSecretAccessKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter AWS Secret Access Key"
        required
        error={errors.parameters?.awsSecretAccessKey?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default S3DirectoryListTaskForm;
